import React from "react";

import AsPercentageSvg from "../../assets/images/icons/as_percentage.svg";

export const AsPercentageIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={AsPercentageSvg}
        alt={alt || "As Percentage"}
    />
);
